// ProjectStatsBar.js — clickable stat tiles that drive status filter
import React from 'react';
import { Box, Typography } from '@mui/material';
import { UnitTableStyles, STATUS_DOT } from '../../../../utils/inventory_helper';

const T = {
  g50: '#eef7f1',
  mint: '#00c46d',
  ink: '#0f1f15',
  muted: '#506459',
  subtle: '#7a9585',
  border: '#e0ece4',
  white: '#ffffff',
  surface: '#f4f8f5',
};
const STAT_ITEMS = [
  { key: 'total',     label: 'Total',     numColor: UnitTableStyles.ink,        filter: 'all'       },
  { key: 'available', label: 'Available', numColor: UnitTableStyles.mint,       filter: 'available' },
  { key: 'booked',    label: 'Booked',   numColor: '#991b1b',    filter: 'booked'    },
  { key: 'blocked', label: 'On Hold', numColor: '#92400e', filter: 'blocked'},
  { key: 'not_available', label: 'Not Available', numColor: STATUS_DOT.not_available.color, filter: 'not_available'},
];
export default function ProjectStatsBar({ summary, loading, onFilterChange, activeFilter = 'all' }) {
  const data = summary || { total: 0, available: 0, booked: 0, sold: 0, blocked: 0, not_available: 0 };

  return (
    <Box
      sx={{
        display: 'flex',
        background: UnitTableStyles.white,
        border: `1px solid ${UnitTableStyles.border}`,
        borderRadius: '12px',
        overflow: 'hidden',
        mb: '12px',
      }}
    >
      {STAT_ITEMS.map(({ key, label, numColor, filter }, idx) => {
        const isActive = (activeFilter || 'all') === filter;
        const isLast = idx === STAT_ITEMS.length - 1;
        return (
          <Box
            key={key}
            onClick={() => onFilterChange?.(filter)}
            sx={{
              flex: 1, px: '14px', py: '11px',
              cursor: 'pointer', textAlign: 'center',
              borderRight: isLast ? 'none' : `1px solid ${UnitTableStyles.border}`,
              borderBottom: isActive ? `2px solid ${UnitTableStyles.mint}` : '2px solid transparent',
              background: isActive ? UnitTableStyles.g50 : UnitTableStyles.white,
              transition: 'background 150ms ease',
              '&:hover': { background: UnitTableStyles.g50 },
            }}
          >
            <Typography sx={{
              fontFamily: "'Fraunces', 'Georgia', serif",
              fontSize: '20px', fontWeight: 700,
              color: loading ? UnitTableStyles.subtle : numColor,
              lineHeight: 1,
            }}>
              {loading ? '—' : (data[key] ?? 0)}
            </Typography>
            <Typography sx={{
              fontSize: '10px', fontWeight: 700, textTransform: 'uppercase',
              letterSpacing: '0.5px', color: UnitTableStyles.subtle, mt: '1px',
            }}>
              {label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
